export enum Sports {
  Basketball = "basketball",
  Hockey = "hockey",
  Ice3 = "ice3",
  Handball = "handball",
  Volleyball = "volleyball",
  Tennis = "tennis",
}
